import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import type { Activity } from '@/types'
import * as activityApi from '../../services/api/activity'

interface ActivityState {
  activities: Record<string, Activity[]> // issueId -> activities
  loading: boolean
  error: string | null
}

const initialState: ActivityState = {
  activities: {},
  loading: false,
  error: null,
}

// 取得議題活動記錄
export const fetchActivities = createAsyncThunk(
  'activity/fetchActivities',
  async (issueId: string) => {
    const response = await activityApi.getActivities(issueId)
    return { issueId, activities: response.data?.activities || [] }
  }
)

const activitySlice = createSlice({
  name: 'activity',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null
    },
    clearActivities: (state, action) => {
      if (action.payload) {
        delete state.activities[action.payload]
      } else {
        state.activities = {}
      }
    },
    addActivity: (state, action) => {
      const { issueId, activity } = action.payload
      if (state.activities[issueId]) {
        state.activities[issueId].unshift(activity) // 新活動加到最前面
      } else {
        state.activities[issueId] = [activity]
      }
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch activities
      .addCase(fetchActivities.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchActivities.fulfilled, (state, action) => {
        state.loading = false
        const { issueId, activities } = action.payload
        state.activities[issueId] = activities
      })
      .addCase(fetchActivities.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || '載入活動記錄失敗'
      })
  },
})

export const { clearError, clearActivities, addActivity } = activitySlice.actions
export default activitySlice.reducer